<template>
	<button
      class="c-screen-indicator online-indicator"
      :class="{ 'status-online': haveScreen }"
      :data-url="url"
      @click="openModal"
      ref="button"
  >
		<span class="online-indicator__status"></span> Presentatiescherm
	</button>
</template>

<script>
export default {
	name: 'ScreenIndicator',
	props: {
		token: String,
		haveScreen: Boolean,
	},
	computed: {
		url() {
			return `${process.env.MIX_APP_URL}/presentation-screen-modal/${this.token}`;
		},
	},
  methods: {
	  openModal(){
      window.modal.openModalWithUrl(this.$refs.button.dataset.url);
    }
  }
};
</script>

<style></style>
